module.exports = __webpack_public_path__ + "static/img/add_teacher_bg.0eced26d.png";